export default "__VITE_ASSET__DBuvBdoR__"